export function setSlugsInHash(slugs: string[]) {
  window.location.hash = '#' + slugs.join('|');
}

export function getSlugsFromHash(): string[] | null {
  const ret = window.location.hash.slice(1).split('|');
  if (ret.length === 1 && !ret[0]) {
    return null;
  }
  return ret;
}
